import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { createTenant } from '../../api/api';

const CreateTenantModal = ({ show, onHide, onCreated, tenants = [] }) => {
  const [form, setForm] = useState({ id: '', name: '', slug: '', parent_tenant_id: '' });
  const [saving, setSaving] = useState(false);

  // Only top-level tenants (no parent of their own) can be a parent —
  // matches the backend's 2-level hierarchy validation.
  const eligibleParents = tenants.filter(t => !t.parent_tenant_id);

  const submit = async () => {
    setSaving(true);
    try {
      await createTenant({
        id: form.id,
        name: form.name,
        slug: form.slug,
        parent_tenant_id: form.parent_tenant_id || null,
      });
      onHide();
      onCreated();
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Create Tenant</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-2">
            <Form.Label>Tenant ID (internal)</Form.Label>
            <Form.Control
              value={form.id}
              onChange={e => setForm({ ...form, id: e.target.value })}
            />
          </Form.Group>

          <Form.Group className="mb-2">
            <Form.Label>Name</Form.Label>
            <Form.Control
              value={form.name}
              onChange={e => setForm({ ...form, name: e.target.value })}
            />
          </Form.Group>

          <Form.Group>
            <Form.Label>Slug</Form.Label>
            <Form.Control
              value={form.slug}
              onChange={e => setForm({
                ...form,
                slug: e.target.value.toLowerCase().replace(/[^a-z0-9-]/g, '-')
              })}
            />
          </Form.Group>

          <Form.Group>
            <Form.Label>Parent tenant (optional)</Form.Label>
            <Form.Select
              value={form.parent_tenant_id}
              onChange={e => setForm({ ...form, parent_tenant_id: e.target.value })}
            >
              <option value="">None — standalone tenant</option>
              {eligibleParents.map(t => (
                <option key={t.id} value={t.id}>{t.name} ({t.slug})</option>
              ))}
            </Form.Select>
            <Form.Text muted>
              Set this to create the new tenant as a centre under an existing parent (e.g. Samkalp IAS Academy).
            </Form.Text>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>Cancel</Button>
        <Button variant="primary" onClick={submit} disabled={saving}>
          {saving ? 'Creating…' : 'Create'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CreateTenantModal;
